module.exports = __webpack_public_path__ + "img/icon-question-media.12a22946.svg";